<template>
  <!-- <div class="category-header">
    <span>{{ name }}</span>
  </div> -->
  <h5>{{ name }}</h5>
<div class="challenge-container">
  <Challenge v-for="challenge in getChallenges()" :challenge="challenge" :key="challenge.id"/>
  <ChallengeChain v-for="challenge in getChains()" :challenge="challenge" :key="challenge.id" />
</div>
</template>

<script>
// TODO fun idea: make an algorithm that packs the challenges in as few rows as possible
import Challenge from '@/components/Challenge.vue'
import ChallengeChain from '@/components/ChallengeChain.vue'
export default {
    props: ['name'],
    methods: {
        getChallenges () {
            return Object.values(this.$store.state.challenges).filter(c => c.categories[0] === this.name && c.unlocked_by === null && c.unlocks == null)
        },
        getChains () {
            return Object.values(this.$store.state.challenges).filter(c => c.categories[0] === this.name && c.unlocked_by === null && c.unlocks != null)
        },
    },
    components: {
        Challenge,
        ChallengeChain,
    },
}
</script>

<style scoped>
.challenge-container {
  display: flex;
  flex-wrap: wrap;
}
h5 {
  margin-bottom: 0;
}
</style>
